import AcHtmlElement from "../helpers/html-element";
export default class ScreenOptionsColumns {
    constructor(columns) {
        this.columns = columns;
        columns.getColumnNames().forEach((column_name) => {
            let column = columns.get(column_name);
            let input = ScreenOptionsColumns.getInputByName(column.name);
            if (input && input.parentElement.textContent.length === 0) {
                input.parentElement.appendChild(AcHtmlElement.create('span').addHtml(column.label).element);
            }
        });
    }
    static getInputByName(name) {
        let input = document.querySelector(`input[name='${name}-hide']`);
        return input ? input : false;
    }
}
